import request from '@/utils/request'


// 查询商品评价列表
export function listGoodsEvaluate(query) {
  return request({
    url: '/biz/admin/order/goods/evaluate/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询商品评价分页
export function pageGoodsEvaluate(query) {
  return request({
    url: '/biz/admin/order/goods/evaluate/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询商品评价详细
export function getGoodsEvaluate(data) {
  return request({
    url: '/biz/admin/order/goods/evaluate/detail',
    method: 'get',
    params: data
  })
}

// 新增商品评价
export function addGoodsEvaluate(data) {
  return request({
    url: '/biz/admin/order/goods/evaluate/add',
    method: 'post',
    data: data
  })
}

// 修改商品评价
export function replayGoodsEvaluate(data) {
  return request({
    url: '/biz/admin/order/goods/evaluate/reply',
    method: 'post',
    data: data
  })
}
export function goodsEvaluateReplyList(data) {
  return request({
    url: '/biz/admin/order/goods/evaluate/reply/list',
    method: 'post',
    data: data
  })
}

export function goodsEvaluateStatus(data) {
  return request({
    url: '/biz/admin/order/goods/evaluate/status',
    method: 'post',
    data: data
  })
}


// 删除商品评价
export function delGoodsEvaluate(data) {
  return request({
    url: '/biz/admin/order/goods/evaluate/delete',
    method: 'post',
    data: data
  })
}
